import Drawer from 'antd/lib/drawer';
import './index.less';

export default Drawer;



// WEBPACK FOOTER //
// ./src/elements/drawer/index.js